<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0" v-if="status">
          <div class="card card-box mb-3 " style="border-radius : 0%">
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Informasi Klinik
                    </h4>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1" label="Nama Klinik">
                      <b-form-input
                        id="input-1"
                        v-model="formDataKlinik[0].nama_klinik"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for=""
                        >No. izin Klinik<span style="color:red">*</span></label
                      >
                      <b-form-input
                        :disabled="!btnDisable"
                        type="text"
                        maxlength="50"
                        v-model="formDataKlinik[1].nomor_ijin"
                        @input="cekValue($event)"
                        @keyup="
                          onChangeValue(
                            formDataKlinik[1].nomor_ijin,
                            '1',
                            'nomor_ijin'
                          )
                        "
                      ></b-form-input>
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[1].desc != null ||
                            formDataKlinik[1].desc != ''
                        "
                      >
                        {{ formDataKlinik[1].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for=""
                        >Alamat Klinik<span style="color:red">*</span></label
                      >
                      <b-form-textarea
                        id="textarea"
                        v-model="formDataKlinik[2].alamat"
                        rows="3"
                        max-rows="6"
                        @keyup="
                          onChangeValue(formDataKlinik[2].alamat, '2', 'alamat')
                        "
                        :disabled="!btnDisable"
                      ></b-form-textarea>
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[2].desc != null ||
                            formDataKlinik[2].desc != ''
                        "
                      >
                        {{ formDataKlinik[2].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for=""
                        >Kab/Kota<span style="color:red">*</span></label
                      >
                      <vue-select
                        style="font-size:13px"
                        :options="optionKota"
                        @input="inputKota($event)"
                        v-model="selectedKota"
                        placeholder="Pilih Kab/Kota"
                        :disabled="!btnDisable"
                      />
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[3].desc != null ||
                            formDataKlinik[3].desc != ''
                        "
                      >
                        {{ formDataKlinik[3].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for=""
                        >Kategori Pasien<span style="color:red">*</span></label
                      >
                      <multiselect
                        class="__multi-select-tarif mt-2"
                        v-model="selectedPasien"
                        placeholder="Pilih Kategori Pasien"
                        :options="optionPasien"
                        :multiple="true"
                        label="label"
                        @input="clearKategori($event)"
                        open-direction="bottom"
                        track-by="label"
                        selectLabel="Pilih Kategori"
                        deselectLabel="Batalkan"
                        selectedLabel="Terpilih"
                        :preselect-first="true"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :disabled="!btnDisable"
                      >
                      </multiselect>
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[4].desc != null ||
                            formDataKlinik[4].desc != ''
                        "
                      >
                        {{ formDataKlinik[4].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for=""
                        >No. Telp Klinik<span style="color:red">*</span></label
                      >
                      <b-form-input
                        class="mt-2"
                        v-model="formDataKlinik[5].nomor_telp"
                        maxlength="14"
                        @keypress="
                          onKeyInputNumber({
                            rawLabel: 'nomor_telp',
                            $event
                          })
                        "
                        @keyup="
                          onChangeValue(
                            formDataKlinik[5].nomor_telp,
                            '5',
                            'nomor_telp',
                            $event
                          )
                        "
                        :disabled="!btnDisable"
                      ></b-form-input>
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[5].desc != null ||
                            formDataKlinik[5].desc != ''
                        "
                      >
                        {{ formDataKlinik[5].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-1"
                      label="Upload SIUP/SIP Klinik"
                    >
                      <div
                        id="upload-box"
                        class="row justify-content-md-center"
                      >
                        <b-button
                          variant="dark"
                          @click="!btnDisable ? '#' : $refs.fileInput.click()"
                        >
                          <span class="btn-wrapper--icon">
                            <font-awesome-icon icon="folder" />
                          </span>
                          <span class="btn-wrapper--label">Cari File</span>
                        </b-button>
                        <input
                          type="file"
                          accept="image/*,.pdf"
                          @change="onFileSelected"
                          @click="resetFileInput"
                          style="display:none"
                          ref="fileInput"
                          multiple="multiple"
                        />
                      </div>
                      <br />
                      <small class="mt-3"
                        ><i
                          >* format yang diizinkan: jpeg, jpg, png, pdf, maks 2
                          MB.</i
                        ></small
                      >
                    </b-form-group>
                    <br />
                    <div
                      v-for="(item, index) in selectedFiles"
                      :key="item.index"
                      class="row file-upload"
                    >
                      <div class="col-md-4">
                        <label class="text-break">{{ item.name }}</label>
                      </div>
                      <div class="col-md-2">
                        <label>{{ item.size / 1000 }} KB</label>
                      </div>
                      <div class="col-md-3">
                        <b-progress :max="100">
                          <b-progress-bar
                            :value="fileProgress[item.name]"
                            :label="`${Math.round(fileProgress[item.name])}%`"
                          ></b-progress-bar>
                        </b-progress>
                      </div>
                      <div class="col-md-3">
                        <div class="row d-flex justify-content-end mr-2">
                          <a
                            @click.prevent="donwloadImage(item)"
                            v-if="item.from_api"
                          >
                            <font-awesome-icon
                              icon="download"
                              class="font-size-xl grow icon"
                              style="margin-right:20px"
                            />
                          </a>
                          <a v-else @click="downloadFile(item)">
                            <font-awesome-icon
                              icon="download"
                              class="font-size-xl grow icon"
                              style="margin-right:20px"
                            />
                          </a>
                          <font-awesome-icon
                            icon="eye"
                            class="font-size-xl grow icon"
                            style="margin-right:20px"
                            v-if="isShow(item)"
                            @click="readFile(item)"
                          />
                          <template v-if="!btnDisable">
                            <font-awesome-icon
                              icon="trash"
                              class="font-size-xl grow icon"
                            />
                          </template>
                          <template v-else>
                            <font-awesome-icon
                              icon="trash"
                              style="cursor:pointer"
                              class="font-size-xl grow icon"
                              @click="removeFile(item, index)"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-1"
                      label="No. WhatsApp Klinik"
                    >
                      <b-form-input
                        id="input-1"
                        v-model="formDataKlinik[7].nomor_wa"
                        @keypress="
                          onKeyInputNumber({
                            rawLabel: 'nomor_wa',
                            $event
                          })
                        "
                        maxlength="14"
                        :disabled="!btnDisable"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-12 mb-3">
                    <b-button
                      variant="primary"
                      v-if="btnDisable"
                      class="float-right"
                      @click="onSubmit"
                      >SIMPAN DATA</b-button
                    >
                    <b-button
                      variant="primary"
                      v-if="!btnDisable"
                      @click="btnDisable = true"
                      class="float-right"
                      >EDIT DATA</b-button
                    >
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "lodash/startCase";
import moment from "moment";
import { mapGetters } from "vuex";
moment.locale("id");
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faDownload,
  faTrash,
  faEye
} from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faDownload, faTrash, faEye);
import Multiselect from "vue-multiselect";
import debounce from "lodash/debounce";

import { ImageCompressor } from "compressor-img";

export default {
  components: {
    Multiselect,
    "vue-select": () => import("@/components/VueSelect.vue"),
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar")
  },
  data() {
    return {
      formDataKlinik: null,
      selectedKota: [],
      optionKota: [],
      inChange: false,
      status: false,

      imageProps: {
        width: 75,
        height: 75
      },

      btnDisable: false,

      selectedPasien: [],
      optionPasien: [],

      selectedFiles: [],
      fileReaderPromises: [],
      uploadedFiles: [],
      fileProgress: [],
      promises: [],
      supportedFiles: ["png", "jpg", "jpeg", "pdf"]
    };
  },
  mounted() {
    this.getProfile();
    this.cekPaketNolock();
    this.getKategori();
    this.getKota();

    window.scrollTo({
      top: 100,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  watch: {
    dataProfile: {
      handler: function(val) {
        if (val) {
          this.fetchImg();
        }
      },
      deep: true
    }
  },
  methods: {
    isShow(d) {
      if (d.name != undefined) {
        const accept = ["jpeg", "jpg", "png", "JPEG", "JPG", "PNG", "pdf"];
        let ext =
          d.uploaded_name != null
            ? d.uploaded_name.split(".").pop()
            : d.name.split(".").pop();
        if (accept.includes(ext)) return true;
        else return false;
      } else {
        return false;
      }
    },
    //convert b64 to blob
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    //compress if file images
    compressImage(file) {
      this.fileReaderPromises.push(
        new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onloadend = () => {
            let imageCompressor = new ImageCompressor({
              onSuccess: response => {
                let ImageURL = response.compressed;
                let block = ImageURL.split(";");
                let contentType = block[0].split(":")[1];
                let realData = block[1].split(",")[1];
                let blob = this.b64toBlob(realData, contentType);
                resolve({ name: file.name, file: blob, size: blob.size });
              },
              scale: 70,
              quality: 70,
              originalImage: reader.result
            });
          };
          reader.readAsDataURL(file);
        })
      );
    },
    //prepare formData
    prepareUpload(filename, file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("filename", filename);
      formData.append("type", "klinik");

      this.promises.push(
        this.$axios
          .post(`klinik/upload/sip/${this.getKlinikId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if (res.data.status) this.uploadedFiles.push(res.data);
          })
          .catch(e => {
            this.$swal({
              type: "warning",
              text: `Format file melebihi ukuran 1 MB!`
            }).then(() => {
              let rmIndex = this.selectedFiles
                .map(item => {
                  return item.name;
                })
                .indexOf(filename);
              this.selectedFiles.splice(rmIndex, 1);
            });
          })
      );
    },
    isFileImage(file) {
      const acceptedImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "pdf"
      ];
      return file && acceptedImageTypes.includes(file["type"]);
    },
    async onFileSelected(event) {
      const {
        target: { files }
      } = event;
      this.fileReaderPromises = [];

      if (
        this.selectedFiles.some(x =>
          Object.keys(files)
            .filter(item => item !== "length")
            .some(item => files[item].name === x.name)
        )
      ) {
        this.$swal({
          type: "error",
          text: "Anda tidak bisa memasukkan data yang sama!"
        });
        return false;
      }

      var a = document.getElementsByClassName("file-upload");
      if (a.length + event.target.files.length > 1) {
        this.$swal({
          type: "warning",
          text: "Upload maksimal 1 File!"
        });
        return;
      }

      for (let i = 0; i < event.target.files.length; i++) {
        if (i == 1 || this.selectedFiles.length == 1) {
          this.$swal({
            type: "warning",
            text: "Upload maksimal 1 File!"
          });
          return;
        }
        let file = event.target.files[i];
        let extension = file.name.split(".").pop();

        if (this.supportedFiles.includes(extension.toLowerCase())) {
          if (this.isFileImage(file)) {
            this.compressImage(file);
          } else {
            file = {
              name: file.name,
              file: file,
              size: file.size,
              from_api: false
            };
            this.selectedFiles.push(file);
          }
        } else {
          this.$swal({
            type: "warning",
            text:
              "Format file salah! Hanya dapat upload format JPG, JPEG, PDF, PNG!"
          });
        }
      }

      await Promise.all(this.fileReaderPromises)
        .then(res => {
          res.map(item => {
            this.selectedFiles.push(item);
          });
        })
        .then(this.processUpload);
    },
    async processUpload() {
      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (!item.isUploading && !item.from_api) {
            this.prepareUpload(item.name, item.file);
            item.isUploading = true;
          }
        });
      }

      try {
        await Promise.all(this.promises).then(res => {
          res.map((item, index) => {
            if (!item.data.status) {
              return this.$swal({
                type: "error",
                title: "Oops...",
                text: item.data.message
              }).then(() => {});
            } else {
              this.uploadedFiles = res.reduce((unique, item) => {
                return unique.includes(item.data)
                  ? unique
                  : [...unique, item.data];
              }, []);
            }
          });
        });
      } catch (e) {
        // console.log(e)
      }

      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (item.from_api) {
            this.uploadedFiles.push(item);
          }
        });
      }
    },
    async donwloadImage(item) {
      const a = document.createElement("a");
      a.href = await this.toDataURL(item.url);
      a.download = item.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          return URL.createObjectURL(blob);
        });
    },
    //download selected file
    downloadFile(item) {
      if (item.from_api == true) {
        window.open(item.url || item.file, "_blank");
      } else {
        const data = window.URL.createObjectURL(item.file);
        const link = document.createElement("a");
        link.href = data;
        link.download = item.name;
        link.click();
        setTimeout(function() {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    },
    //view selected file
    readFile(item) {
      if (item.from_api == true) {
        window.open(item.file);
      } else {
        const data = window.URL.createObjectURL(item.file);
        window.open(data);
      }
    },
    //remove selected file
    removeFile(file, index) {
      let profile;

      this.$store.state.klinikUser.map(data => {
        if (data.parent_id != null && data.id == this.getKlinikId) {
          profile = data.parent_id;
        }
      });

      this.selectedFiles.splice(index, 1);
      this.promises.splice(index, 1);

      let filename = file.name;
      filename = filename.split(" ").join("_");
      filename = filename.split(".").join("_");

      this.$axios.post(`klinik/delete-sip/${this.getKlinikId}`, {
        type: "klinik"
      });

      let removeIndex = this.uploadedFiles
        .map(item => {
          return item.name;
        })
        .indexOf(filename);

      this.uploadedFiles.splice(removeIndex, 1);
    },
    resetFileInput() {
      const x = this.$refs.fileInput;
      x.value = "";
    },
    inputKota(data) {
      this.formDataKlinik[3].kota = data;
    },
    clearKategori(data) {
      this.formDataKlinik[4].kategori = data;

      if (data.length == 0) {
        this.formDataKlinik[4].error = true;
        this.formDataKlinik[4].desc = "Kolom harus diisi";
      } else {
        this.formDataKlinik[4].error = false;
        this.formDataKlinik[4].desc = null;
      }
    },
    onKeyInputNumber({ rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    onChangeValue(data, index, label) {
      if (data == null || data.length == 0 || data == "") {
        this.formDataKlinik[index].desc = "Kolom harus diisi";
        this.formDataKlinik[index].error = true;
      } else {
        this.formDataKlinik[index].error = false;
        this.formDataKlinik[index].desc = null;
      }
    },
    cekValue: debounce(function(val) {
      this.$axios
        .get(`klinik/no_izin/cek`, {
          params: {
            no_izin: val
          }
        })
        .then(res => {
          if (res.data.status) {
            this.formDataKlinik[1].error = false;
            this.formDataKlinik[1].desc = null;
          } else if (res.data.status == false) {
            this.formDataKlinik[1].error = true;
            this.formDataKlinik[1].desc = "No. izin klinik telah ditambahkan";
          }
        });
    }, 500),
    async getProfile() {
      try {
        let profile;

        this.$store.state.klinikUser.map(data => {
          if (data.parent_id != null && data.id == this.getKlinikId) {
            profile = data.parent_id;
          }
        });

        const res = await this.$axios.get(
          `klinik/${this.getKlinikId}?klinik_id=${profile}&profile=true`
        );

        const { data } = res.data;

        this.$nextTick(() => {
          this.photo = data.foto_klinik;
        });

        if (data.kategoriPasien.length != 0 || data.kategoriPasien != null) {
          this.selectedPasien = data.kategoriPasien.map(item => {
            return {
              id: item.id,
              label: item.nama,
              value: item.id
            };
          });
        }

        if (data.nomor_ijin_file != null) {
          this.$set(this.fileProgress, data.nomor_ijin_file.name, 100);
          this.selectedFiles.push({
            name: data.nomor_ijin_file.name,
            size: data.nomor_ijin_file.size,
            file: data.nomor_ijin_file.url,
            url: data.nomor_ijin_file.url,
            from_api: true,
            uploaded_name: data.nomor_ijin_file.upload_name
          });
        }

        if (data.kota != null) {
          this.selectedKota = {
            id: data.kota.id,
            label: data.kota.nama,
            value: data.kota.id
          };
        }

        this.formDataKlinik = [
          //0
          {
            nama_klinik: data.nama_klinik,
            error: null,
            desc: null
          },
          //1
          {
            nomor_ijin: data.nomor_ijin == null ? "" : data.nomor_ijin,
            error: null,
            desc: null
          },
          //2
          {
            alamat: data.alamat == null ? "" : data.alamat,
            error: null,
            desc: null
          },
          //3
          {
            kota: this.selectedKota,
            error: null,
            desc: null
          },
          //4
          {
            kategori: this.selectedPasien,
            error: null,
            desc: null
          },
          //5
          {
            nomor_telp: data.nomor_telp == null ? "" : data.nomor_telp,
            error: null,
            desc: null
          },
          //6
          {
            file_siup: data.nomor_ijin_file,
            error: null,
            desc: null
          },
          //7
          {
            nomor_wa: data.nomor_wa == null ? "" : data.nomor_wa,
            error: null,
            desc: null
          }
        ];

        this.status = true;
      } catch (e) {}
    },
    onSubmit() {
      let err = false;

      if (
        this.formDataKlinik[1].nomor_ijin == null ||
        this.formDataKlinik[1].nomor_ijin == "" ||
        this.formDataKlinik[1].nomor_ijin.length == 0
      ) {
        err = true;
        this.formDataKlinik[1].desc = "Kolom harus diisi";
        this.formDataKlinik[1].error = true;
      }

      if (
        this.formDataKlinik[2].alamat == null ||
        this.formDataKlinik[2].alamat == "" ||
        this.formDataKlinik[2].alamat.length == 0
      ) {
        err = true;
        this.formDataKlinik[2].desc = "Kolom harus diisi";
        this.formDataKlinik[2].error = true;
      }
      if (
        this.formDataKlinik[3].kota == null ||
        this.formDataKlinik[3].kota == "" ||
        this.formDataKlinik[3].kota.length == 0
      ) {
        err = true;
        this.formDataKlinik[3].desc = "Kolom harus diisi";
        this.formDataKlinik[3].error = true;
      }
      if (
        this.formDataKlinik[4].kategori == null ||
        this.formDataKlinik[4].kategori == "" ||
        this.formDataKlinik[4].kategori.length == 0
      ) {
        err = true;
        this.formDataKlinik[4].desc = "Kolom harus diisi";
        this.formDataKlinik[4].error = true;
      }
      if (
        this.formDataKlinik[5].nomor_telp == null ||
        this.formDataKlinik[5].nomor_telp == "" ||
        this.formDataKlinik[5].nomor_telp.length == 0
      ) {
        err = true;
        this.formDataKlinik[5].desc = "Kolom harus diisi";
        this.formDataKlinik[5].error = true;
      }

      if (err) {
        this.$swal({
          // title: "Gagal",
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
        return;
      } else {
        this.updateProses();
      }
    },
    async updateProses() {
      try {
        let id;

        this.$store.state.klinikUser.map(data => {
          if (data.parent_id != null && data.id == this.getKlinikId) {
            id = data.parent_id;
          }
        });

        const res = await this.$axios.put(
          `klinik/${this.getKlinikId}`,
          {
            profile: true,
            nomor_wa: this.formDataKlinik[7].nomor_wa,
            nomor_telp: this.formDataKlinik[5].nomor_telp,
            alamat: this.formDataKlinik[2].alamat,
            nomor_ijin: this.formDataKlinik[1].nomor_ijin,
            kota: this.selectedKota.id,
            kategori_pasien: this.selectedPasien.map(item => {
              return item.value;
            })
          }
        );
        if (res.data.status) {
          this.$swal({
            type: "success",
            title: startCase("Simpan Data Informasi Klinik"),
            text: startCase("Simpan Data Informasi Klinik berhasil.")
          });
          this.btnDisable = false;
        } else {
          this.$swal({
            text: `Silakan lengkapi seluruh kolom!`,
            type: "warning",
            confirmButtonText: startCase("ya")
          });
        }
      } catch {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`kategori-pasien?klinik_id=${this.getKlinikId}`);
        const { data } = res.data;
        this.optionPasien = data.map(item => {
          return {
            label: `${item.nama}`,
            value: item.id
          };
        });
      } catch (error) {}
    },
    async getKota() {
      try {
        const res = await this.$axios.get(`getcity`);
        const { data } = res.data;
        this.optionKota = data.map(item => {
          return {
            id: item.id,
            label: item.nama
          };
        });
      } catch (error) {}
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.picture-inner {
  top: -120px !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}

._outer_klinik_profile {
  cursor: pointer;
}

.__outer_line_profile {
  border-right: rgb(121, 121, 121);
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-right-style: solid;
}

.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: 15px;
  z-index: 10;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.badge-alert {
  background-color: #ffffff;
  border: solid 1px rgba(7, 9, 25, 0.5) !important;
  border-radius: 50%;
  cursor: pointer;
}
</style>
